import React from 'react'
import { useQuery } from "@apollo/client"
import { Link } from "react-router-dom"
import { GET_ANNOUNCES_COUNT } from "../../../graphql/index"
import { serialize } from "../../../utils"
import moment from "moment"
import { INITIAL_FILTER } from "../../../constant"
import css from './Announces.module.scss'
import lCss from '../../Layout/Layout.module.scss'

export default function LinkMore ({ variables = INITIAL_FILTER, limit = 10, query = GET_ANNOUNCES_COUNT}) {
	const { loading, data } = useQuery(query,{variables: serialize(variables)})

	return (
		<div className={css.LinkMore}>
			{!loading && data?.resultCounter > limit ? <Link to={'/main' + '?fd=' + moment(variables?.fd).format('YYYYMMDD') + (variables?.td ? '&td=' + moment(variables?.td).format('YYYYMMDD') : '')} className={lCss.button + ' '+ lCss.mt20}>Смотреть все события</Link> : null}
		</div>
	)
}